import {configureStore} from '@reduxjs/toolkit';
import  LogginReduces from './login';
import snackBarSlice  from './snackBar';
import customizationReducer from './customizationReducer'
import menuReducer from './menu'
import permissionReducer from './permissionReducer';
import orderReducer from './order'
import dashboaedSlice from "./dashboard"
export default configureStore({
    reducer : {
        logged:LogginReduces,
        snackBar:snackBarSlice,
        customization: customizationReducer,
        menu:menuReducer,
        permission:permissionReducer,
        order:orderReducer,
        dashboard :dashboaedSlice
    }
})